export { default } from "./FiltersConfigs";
